/**
 * Add "floating-label" CSS class to all inputs and corresponding labels where applicable
 */
export const floatingFormLabels = () => {
  /** @type {NodeListOf<HTMLElement>} Buttons */
  const applicableInputs = document.querySelectorAll(
    'textarea, input:not([type="checkbox"]):not([type="radio"]):not([type="select"]):not([type="search"]):not([type="file"]):not([name="wpforms[hp]"]):not([type="range"]):not(.wpforms-field-date-time-date):not(.wpforms-field-date-time-time):not(.wpforms-datepicker):not([class*="wpforms-payment-"]):not([class*="paypal-commerce"]):not(.dropzone-input)'
  )

  /**
   * Create a map of inputs with their corresponding labels
   */
  const inputToLabelMap = new Map()

  applicableInputs.forEach(input => {
    // Exit if input.parentElement has class is-not-floating

    if (input.parentElement.classList.contains('is-not-floating')) {
      return
    }

    const inputSiblings = Array.from(input.parentElement.childNodes)

    const label = inputSiblings.find(
      sibling =>
        sibling.htmlFor &&
        (input.id === sibling.htmlFor || input.name === sibling.htmlFor)
    )

    if (label && !label.classList.contains('wpforms-error')) {
      inputToLabelMap.set(input, label)

      input.classList.add('floating-label')
      label.classList.add('floating-label')

      // Add "floating-label--filled" class if already pre-filled on load
      input.value.length > 0
        ? label.classList.add('floating-label--filled')
        : label.classList.remove('floating-label--filled')
    }
  })

  /**
   * Add "floating-label--focussed" class on focus
   */
  const addFocusClass = el => {
    const input = el.target
    const label = inputToLabelMap.get(input)

    if (label) {
      label.classList.add('floating-label--focussed')
      input.classList.add('floating-label--focussed')
    }
  }

  /**
   * Remove "floating-label--focussed" class on blur
   */
  const removeFocusClass = el => {
    const input = el.target
    const label = inputToLabelMap.get(input)

    if (label) {
      label.classList.remove('floating-label--focussed')
      input.classList.remove('floating-label--focussed')
    }
  }

  /**
   * Update "floating-label--filled" class on input change
   */
  const updateFilledClass = el => {
    const input = el.target
    const label = inputToLabelMap.get(input)

    if (label) {
      if (input.value.length > 0) {
        label.classList.add('floating-label--filled')
        input.classList.add('floating-label--filled')
        return
      }
      label.classList.remove('floating-label--filled')
      input.classList.remove('floating-label--filled')
    }
  }

  applicableInputs.forEach(input => {
    input.addEventListener('focus', addFocusClass, true)
    input.addEventListener('blur', removeFocusClass, true)
    input.addEventListener('input', updateFilledClass, true)
  })
}

/**
 * Trigger form lables (HubSpot)
 */
export const formLabelsHS = component => {
  const applicableInputs = component.querySelectorAll(
    'input:not([type="checkbox"]):not([type="radio"]):not([type="select"]):not([type="search"]):not([type="file"]):not([type="range"]):not(.hs-button), textarea, select:not([multiple])'
  )

  const inputToLabelMap = new Map()

  applicableInputs.forEach(input => {
    const inputId = input.id
    const inputGrandparent =
      input.closest('.hs-form-field') || input.parentElement.parentElement
    const label = inputGrandparent.querySelector(`label[for="${inputId}"]`)

    if (label) {
      inputToLabelMap.set(input, label)

      input.classList.add('floating-label')
      label.classList.add('floating-label')

      // Add "floating-label--filled" class if already pre-filled on load
      input.value.length > 0
        ? label.classList.add('floating-label--filled')
        : label.classList.remove('floating-label--filled')
    }
  })

  const addFocusClass = event => {
    const input = event.target
    const label = inputToLabelMap.get(input)

    if (label) {
      label.classList.add('floating-label--focussed')
      input.classList.add('floating-label--focussed')
    }
  }

  const removeFocusClass = event => {
    const input = event.target
    const label = inputToLabelMap.get(input)

    if (label) {
      label.classList.remove('floating-label--focussed')
      input.classList.remove('floating-label--focussed')
    }
  }

  const updateFilledClass = event => {
    const input = event.target
    const label = inputToLabelMap.get(input)

    if (label) {
      input.value.length > 0
        ? label.classList.add('floating-label--filled')
        : label.classList.remove('floating-label--filled')
    }
  }

  applicableInputs.forEach(input => {
    input.addEventListener('focus', addFocusClass, true)
    input.addEventListener('blur', removeFocusClass, true)
    input.addEventListener('input', updateFilledClass, true)
  })

  // Handle placeholders
  applicableInputs.forEach(input => {
    if (
      input.getAttribute('placeholder') &&
      input.getAttribute('placeholder').length
    ) {
      const label = inputToLabelMap.get(input)
      if (label) {
        label.classList.add('floating-label--placeholder')
      }
    }
  })

  // Update IDs to ensure uniqueness
  const labelsWithForAttribute = component.querySelectorAll('label[for]')
  labelsWithForAttribute.forEach(label => {
    const labelForAttribute = label.getAttribute('for')
    const inputField = document.getElementById(labelForAttribute)
    if (inputField) {
      const newId = `${labelForAttribute}-${Date.now()}-${Math.floor(
        Math.random() * 100
      )}`
      label.setAttribute('for', newId)
      inputField.id = newId
    }
  })
}
